import React from 'react';
import Icon from '../../../components/AppIcon';

const StrengthsSection = ({ strengths, confidence }) => {
  return (
    <div className="w-full bg-card rounded-lg border border-border p-4 md:p-6 lg:p-8 shadow-elevation-sm">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-success/10 flex items-center justify-center">
            <Icon name="ThumbsUp" size={24} color="var(--color-success)" />
          </div>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground">
            Property Strengths
          </h2>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Shield" size={16} color="var(--color-muted-foreground)" />
          <span className="text-sm text-muted-foreground text-caption">
            <span className="font-semibold text-data">{confidence}%</span>
          </span>
        </div>
      </div>
      <div className="space-y-3 md:space-y-4">
        {strengths?.map((strength, index) => (
          <div 
            key={index}
            className="flex items-start gap-3 p-3 md:p-4 rounded-lg bg-muted/50 hover:bg-muted transition-base"
          >
            <div className="flex-shrink-0 mt-1">
              <div className="w-6 h-6 rounded-full bg-success/20 flex items-center justify-center">
                <Icon name="Check" size={14} color="var(--color-success)" />
              </div>
            </div>
            <p className="text-sm md:text-base text-foreground leading-relaxed font-body flex-1">
              {strength}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StrengthsSection;